"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M3.5 20.5V8.75h17V20.5h-17Zm0-13.25h17V3.5h-17v3.75ZM22 2H2v20h20V2Zm-11 9.4001v1.1274c4.0846.2359 6 2.0213 6 6.4726-1.7944-2.7392-4.5375-3.4055-6-3.5602v1.1602c0 .1648-.1882.2589-.32.16l-3.4667-2.6a.2.2 0 0 1 0-.32l3.4667-2.6c.1318-.0989.32-.0048.32.16Z", clipRule: "evenodd" })), 'ArchiveRetrieveIcon');
